import React, { Component } from 'react'

// ui
import Pagination from '../../components/uielements/pagination'

// redux
import { connect } from 'react-redux'
import roleActions from '../../redux/qbrole/actions'

class Paginate extends Component {
    onShowSizeChange = (current, pageSize) => {
        this.props.changePageSize(pageSize)
    }

    onChange(pageNumber) {
        this.props.changeCurrentPage(pageNumber)
    }

    render() {
        const { total, pageSize, current } = this.props
        return (
            <div className="PaginateContainer">
                <Pagination
                    showSizeChanger
                    onShowSizeChange={(current, pageSize) => this.onShowSizeChange(current, pageSize)}
                    onChange={pageNumber => this.onChange(pageNumber)}
                    current={current}
                    total={total}
                    showQuickJumper
                    pageSizeOptions={['5', '6', '8', '10', '15']}
                    pageSize={pageSize}
                />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        total: state.qbrole.total,
        pageSize: state.qbrole.pageSize,
        current: state.qbrole.pageIndex
    }
}

const mapDispatchToProps = dispatch => {
    return {
        changePageSize: pageSize => {
            dispatch(roleActions.action.changePageSize(pageSize))
        },
        changeCurrentPage: pageNumber => {
            dispatch(roleActions.action.changeCurrentPage(pageNumber))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Paginate)